import React from 'react';
import { FiList, FiGrid, FiMap } from 'react-icons/fi';

const ViewToggle = ({ viewMode, onViewChange }) => {
  const views = [
    { id: 'list', icon: FiList, label: 'Liste' },
    { id: 'grid', icon: FiGrid, label: 'Grille' },
    { id: 'map', icon: FiMap, label: 'Carte' }
  ];

  return (
    <div className="flex items-center gap-2 bg-gray-800/50 rounded-lg p-1 border border-gray-700">
      {views.map((view) => {
        const Icon = view.icon;
        return (
          <button
            key={view.id}
            onClick={() => onViewChange(view.id)}
            className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
              viewMode === view.id
                ? 'bg-amber-500 text-white'
                : 'text-gray-400 hover:text-white hover:bg-gray-700'
            }`}
            title={view.label}
          >
            <Icon className="w-4 h-4" />
            <span className="hidden sm:inline">{view.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ViewToggle;





